import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {HttpService} from "../../../_service/http.service";
import "rxjs/add/operator/filter";
import {Metrika} from "ng-yandex-metrika";
import {isNullOrUndefined, isUndefined} from "util";
import {ActivatedRoute} from "@angular/router";

@Component({
  templateUrl: './widget-saldo-info.component.html',
  selector: 'app-widget-saldo-info',
  styleUrls: ['../../../../styles.css']
})
export class WidgetSaldoInfoComponent implements OnInit {

  @Output()
  errorEvent = new EventEmitter();
  @Input()
  public saldo;
  @Input()
  alias;
  @Input()
  isFromSite = false;

  emailField: any;
  isRequestCounting = false;
  balanceStatus: any;
  balanceDisplay: any;
  toPayDisplay: any;
  private isMonoblock = false;

  constructor(private metrika: Metrika,
              private route: ActivatedRoute,
              private httpService: HttpService) {
  }

  ngOnInit(): void {
    this.toPayDisplay = this.saldo.toPay;
    this.balanceDisplay = Math.abs(this.saldo.balance);
    this.balanceStatus = this.getBalanceStatus(this.saldo.balance);
    this.emailField = this.saldo.ownerEmail;

    this.isMonoblock = this.route.snapshot.queryParams['type'] === 'monoblock';
  }

  postData() {
    if (this.isRequestCounting) {
      return;
    }

    if(this.saldo.toPay == null) {
      const errorMessage = 'Поле \'К оплате\' обязательно для заполнения';
      this.errorEvent.emit({data: errorMessage});
      return;
    }

    const sb = [];
    sb.push('rest/postData?');
    sb.push('organizationAlias=' + this.alias);
    if (this.isMonoblock) {
      sb.push('&isMonoblock=' + true);
    }
    this.isRequestCounting = true;
    if (this.saldo.isEmailRequired != null) {
      this.saldo.ownerEmail = this.emailField;
    }
    this.saldo.isFromSite = this.isFromSite;

    try {
      if (!isNullOrUndefined(localStorage.getItem('currentUser'))) {

        this.httpService.postDataWithAuth(sb.join(''), this.saldo)
          .then((data) => {
              console.log('Received data in getSuitableAddress is: ', data);
              this.metrika.fireEvent('START_PAYMENT');
              if (window.top !== undefined) {
                window.top.location.href = data.redirect_url;
              } else {
                window.location.href = data.redirect_url;
              }
              this.isRequestCounting = false;
            },
            error => {
              this.errorHandler(error);
              this.isRequestCounting = true;
            })
          .then(value => {
            this.isRequestCounting = false;
          });

        return;

      }
    } catch (e) {
      console.error(e);
    }

    this.httpService.postData(sb.join(''), this.saldo)
      .then((data) => {
          console.log('Received data in getSuitableAddress is: ', data);
          this.metrika.fireEvent('START_PAYMENT');
          if (window.top !== undefined) {
            window.top.location.href = data.redirect_url;
          } else {
            window.location.href = data.redirect_url;
          }
          this.isRequestCounting = false;
        },
        error => {
          this.errorHandler(error);
          this.isRequestCounting = true;
        })
      .then(value => {
        this.isRequestCounting = false;
      });
  }

  errorHandler(error: any) {
    let errorMessage = '';
    this.isRequestCounting = false;
    // this.saldo = null;
    if (error._body.type !== undefined && error._body.type === 'error') {
      errorMessage = 'Не удалось связаться с сервисом. Повторите попытку позже.';
    } else {
      errorMessage = error._body;
    }

    this.errorEvent.emit({data: errorMessage});
    console.log('Error in get account state: ', error._body);
  }

  getBalanceStatus(balance: any) {
    if (balance < 0) {
      return {text: 'К оплате', symbol: ''};
    } else if (balance === 0) {
      return {text: 'Баланс', symbol: ''};
    } else {
      return {text: 'Переплата', symbol: '+'};
    }
  }

  notFindMessage() {
    let result = '';
    if (this.saldo.balance == null) {
      result += 'балансе';
    }
    if (this.saldo.balance == null && this.saldo.billAmount == null) {
      result += ' и ';
    }
    if (this.saldo.billAmount == null) {
      result += 'начислениях за этот месяц';
    }
    return result;
  }

  sendWithEmailCheck() {

    if (isUndefined(this.emailField) || this.emailField === '') {
      const errorMessage = 'Введите Ваш Email для получения подтверждения платежа';
      this.errorEvent.emit({data: errorMessage});
      return false;
    }

    if (!this.emailValidator(this.emailField)) {
      return false;
    }

  }


  emailValidator(email: string): boolean {
    const emailReg = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/, 'mgi');
    if (!emailReg.test(email)) {
      const errorMessage = 'Проверьте правильность введенного Email адреса';
      this.errorEvent.emit({data: errorMessage});
      return false;
    }
    return true;
  }


  moneyInputPatternCheck() {
    this.saldo.toPay = this.saldo.toPay.match('^[0-9]*([,.]?[0-9]{1,2})?')[0];
    this.saldo.toPay = this.saldo.toPay.replace(',', '.');
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/widget-saldo-info/widget-saldo-info.component.ts